import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { hasPainPoints } from "../../utils/bedBuilder.utils";
import CustomerService from "../../api/customer";

export const initialState = {
  mattressConfiguration: {
    bedSize: "",
    isSingleSleeper: true,
  },
  mattressBuilder: {
    primarySleeper: {
      name: "",
      primarySleepStyle: null,
      secondarySleepStyle: null,
      height: "",
      heightFeet: "",
      heightInches: "",
      weight: "",
      unitSystem: "imperial",
      bodyType: null,
      painPoints: {
        hip: false,
        shoulder: false,
        lowerBack: false,
        midBack: false,
      },
      lastSelectedPainPoint: null,
      firmness: 3,
      bmi: NaN,
      evrScore: NaN,
      finalEvrScore: NaN
    },
    secondarySleeper: {
      name: "",
      primarySleepStyle: null,
      secondarySleepStyle: null,
      height: "",
      heightFeet: "",
      heightInches: "",
      weight: "",
      unitSystem: "imperial",
      bodyType: null,
      painPoints: {
        hip: false,
        shoulder: false,
        lowerBack: false,
        midBack: false,
      },
      lastSelectedPainPoint: null,
      firmness: 3,
      bmi: NaN,
      evrScore: NaN,
      finalEvrScore: NaN
    },
  },
  cart: {
    id: "",
  },
};

export const mattressConfigurationSlice = createSlice({
  name: "mattressConfiguration",
  initialState,
  reducers: {
    setBedSize: (state, action) => {
      state.mattressConfiguration.bedSize = action.payload;
    },
    setIsSingleSleeper: (state, action) => {
      // console.log('setIsSingleSleeper');
      state.mattressConfiguration.isSingleSleeper = !action.payload;
      state.mattressConfiguration.bedSize = "";
    },
    setMattressConfiguration: (state, action) => {
      state.mattressConfiguration.mattressConfiguration =
        action.payload.mattressConfiguration;
    },
    setMattressGlobalState: (state, action) => {
      // // console.log("INSIDE setMattressGlobalState", action.payload);
      // console.log(action.payload);
      return { ...action.payload };
    },
    setPrimarySleeperName: (state, action) => {
      state.mattressBuilder.primarySleeper.name = action.payload;
    },
    setSecondarySleeperName: (state, action) => {
      state.mattressBuilder.secondarySleeper.name = action.payload;
    },
    setPrimarySleeperPrimarySleepStyle: (state, action) => {
      state.mattressBuilder.primarySleeper.primarySleepStyle = action.payload;
    },
    setPrimarySleeperSecondarySleepStyle: (state, action) => {
      state.mattressBuilder.primarySleeper.secondarySleepStyle = action.payload;
    },
    setSecondarySleeperPrimarySleepStyle: (state, action) => {
      state.mattressBuilder.secondarySleeper.primarySleepStyle = action.payload;
    },
    setSecondarySleeperSecondarySleepStyle: (state, action) => {
      state.mattressBuilder.secondarySleeper.secondarySleepStyle =
        action.payload;
    },
    setPrimarySleeperHeight: (state, action) => {
      state.mattressBuilder.primarySleeper.height = action.payload;
    },
    setPrimarySleeperHeightFeet: (state, action) => {
      state.mattressBuilder.primarySleeper.heightFeet = action.payload;
    },
    setPrimarySleeperHeightInches: (state, action) => {
      state.mattressBuilder.primarySleeper.heightInches = action.payload;
    },
    setSecondarySleeperHeight: (state, action) => {
      state.mattressBuilder.secondarySleeper.height = action.payload;
    },
    setSecondarySleeperHeightFeet: (state, action) => {
      state.mattressBuilder.secondarySleeper.heightFeet = action.payload;
    },
    setSecondarySleeperHeightInches: (state, action) => {
      state.mattressBuilder.secondarySleeper.heightInches = action.payload;
    },
    setPrimarySleeperWeight: (state, action) => {
      state.mattressBuilder.primarySleeper.weight = action.payload;
    },
    setSecondarySleeperWeight: (state, action) => {
      state.mattressBuilder.secondarySleeper.weight = action.payload;
    },
    setPrimarySleeperBodyType: (state, action) => {
      state.mattressBuilder.primarySleeper.bodyType = action.payload;
    },
    setSecondarySleeperBodyType: (state, action) => {
      state.mattressBuilder.secondarySleeper.bodyType = action.payload;
    },
    setPrimarySleeperBackPainHip: (state, action) => {
      state.mattressBuilder.primarySleeper.painPoints.hip = action.payload;
      if (action.payload) {
        state.mattressBuilder.primarySleeper.lastSelectedPainPoint = "hip";
      } else {
        state.mattressBuilder.primarySleeper.lastSelectedPainPoint =
          hasPainPoints(state.mattressBuilder.primarySleeper.painPoints)[0] ||
          null;
      }
    },
    setPrimarySleeperBackPainShoulder: (state, action) => {
      state.mattressBuilder.primarySleeper.painPoints.shoulder = action.payload;
      if (action.payload) {
        state.mattressBuilder.primarySleeper.lastSelectedPainPoint = "shoulder";
      } else {
        state.mattressBuilder.primarySleeper.lastSelectedPainPoint =
          hasPainPoints(state.mattressBuilder.primarySleeper.painPoints)[0] ||
          null;
      }
    },
    setPrimarySleeperBackPainLowerBackPain: (state, action) => {
      state.mattressBuilder.primarySleeper.painPoints.lowerBack =
        action.payload;
      if (action.payload) {
        state.mattressBuilder.primarySleeper.lastSelectedPainPoint =
          "lowerBack";
      } else {
        state.mattressBuilder.primarySleeper.lastSelectedPainPoint =
          hasPainPoints(state.mattressBuilder.primarySleeper.painPoints)[0] ||
          null;
      }
    },
    setPrimarySleeperBackPainMidBack: (state, action) => {
      state.mattressBuilder.primarySleeper.painPoints.midBack = action.payload;
      if (action.payload) {
        state.mattressBuilder.primarySleeper.lastSelectedPainPoint = "midBack";
      } else {
        state.mattressBuilder.primarySleeper.lastSelectedPainPoint =
          hasPainPoints(state.mattressBuilder.primarySleeper.painPoints)[0] ||
          null;
      }
    },
    setSecondarySleeperBackPainHip: (state, action) => {
      state.mattressBuilder.secondarySleeper.painPoints.hip = action.payload;
      if (action.payload) {
        state.mattressBuilder.secondarySleeper.lastSelectedPainPoint = "hip";
      } else {
        state.mattressBuilder.secondarySleeper.lastSelectedPainPoint =
          hasPainPoints(state.mattressBuilder.secondarySleeper.painPoints)[0] ||
          null;
      }
    },
    setSecondarySleeperBackPainShoulder: (state, action) => {
      state.mattressBuilder.secondarySleeper.painPoints.shoulder =
        action.payload;
      if (action.payload) {
        state.mattressBuilder.secondarySleeper.lastSelectedPainPoint =
          "shoulder";
      } else {
        state.mattressBuilder.secondarySleeper.lastSelectedPainPoint =
          hasPainPoints(state.mattressBuilder.secondarySleeper.painPoints)[0] ||
          null;
      }
    },
    setSecondarySleeperBackPainLowerBackPain: (state, action) => {
      state.mattressBuilder.secondarySleeper.painPoints.lowerBack =
        action.payload;
      if (action.payload) {
        state.mattressBuilder.secondarySleeper.lastSelectedPainPoint =
          "lowerBack";
      } else {
        state.mattressBuilder.secondarySleeper.lastSelectedPainPoint =
          hasPainPoints(state.mattressBuilder.secondarySleeper.painPoints)[0] ||
          null;
      }
    },
    setSecondarySleeperBackPainMidBack: (state, action) => {
      state.mattressBuilder.secondarySleeper.painPoints.midBack =
        action.payload;
      if (action.payload) {
        state.mattressBuilder.secondarySleeper.lastSelectedPainPoint =
          "midBack";
      } else {
        state.mattressBuilder.secondarySleeper.lastSelectedPainPoint =
          hasPainPoints(state.mattressBuilder.secondarySleeper.painPoints)[0] ||
          null;
      }
    },
    setPrimarySleeperFirmness: (state, action) => {
      state.mattressBuilder.primarySleeper.firmness = action.payload;
    },
    setSecondarySleeperFirmness: (state, action) => {
      state.mattressBuilder.secondarySleeper.firmness = action.payload;
    },
    setPrimarySleeperBMI: (state, action) => {
      state.mattressBuilder.primarySleeper.bmi = action.payload;
    },
    setSecondarySleeperBMI: (state, action) => {
      state.mattressBuilder.secondarySleeper.bmi = action.payload;
    },
    setPrimarySleeperEvrScore: (state, action) => {
      state.mattressBuilder.primarySleeper.evrScore = action.payload;
    },
    setSecondarySleeperEvrScore: (state, action) => {
      state.mattressBuilder.secondarySleeper.evrScore = action.payload;
    },
    setPrimarySleeperFinalEvrScore: (state, action) => {
      state.mattressBuilder.primarySleeper.finalEvrScore = action.payload;
    },
    setSecondarySleeperFinalEvrScore: (state, action) => {
      state.mattressBuilder.secondarySleeper.finalEvrScore = action.payload;
    },

    setPrimarySleeperUnitSystem: (state, action) => {
      if (action.payload) {
        state.mattressBuilder.primarySleeper.unitSystem = "imperial";
      } else {
        state.mattressBuilder.primarySleeper.unitSystem = "metric";
      }
    },
    setSecondarySleeperUnitSystem: (state, action) => {
      if (action.payload) {
        state.mattressBuilder.secondarySleeper.unitSystem = "imperial";
      } else {
        state.mattressBuilder.secondarySleeper.unitSystem = "metric";
      }
    },
    setCustomerError: state => {
      state.error = true;
    },
    resetCustomerError: state => {
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(updateMattressConfiguration.pending, state => {
        state.loading = true;
      })
      .addCase(updateMattressConfiguration.rejected, state => {
        state.loading = true;
      })
      .addCase(updateMattressConfiguration.fulfilled, (state, action) => {
        state.loading = false;
        return state;
      })
      .addCase(createCart.pending, state => {
        state.loading = true;
      })
      .addCase(createCart.rejected, state => {
        state.loading = true;
      })
      .addCase(createCart.fulfilled, (state, action) => {
        const {
          data: {
            body: {
              data: { cartCreate },
            },
          },
          code,
          isSuccessful,
        } = action.payload;
        //TODO Set cart Id to redux store
        if (isSuccessful) {
          state.cart = cartCreate.cart;
        }
        state.loading = false;
        return state;
      })
      .addDefaultCase((state, action) => {
        return state;
      });
  },
});

//THUNKS
export const updateMattressConfiguration = createAsyncThunk(
  "slices/updateMattressConfiguration",
  async updatedMattressConfiguration => {
    const { data, code, isSuccessful } =
      await CustomerService.updateMattressConfiguration(
        updatedMattressConfiguration
      );
    return { data, code, isSuccessful };
  }
);

export const createCart = createAsyncThunk("slices/createCart", async cart => {
  const { data, code, isSuccessful } = await CustomerService.createCart(cart);
  return { data, code, isSuccessful };
});

export const {
  setBedSize,
  setIsSingleSleeper,
  setCustomerError,
  setMattressGlobalState,
  setMattressConfiguration,
  setPrimarySleeperPrimarySleepStyle,
  setPrimarySleeperSecondarySleepStyle,
  setSecondarySleeperPrimarySleepStyle,
  setSecondarySleeperSecondarySleepStyle,
  setPrimarySleeperUnitSystem,
  setSecondarySleeperUnitSystem,
  setPrimarySleeperHeight,
  setPrimarySleeperHeightFeet,
  setPrimarySleeperHeightInches,
  setSecondarySleeperHeight,
  setSecondarySleeperHeightFeet,
  setSecondarySleeperHeightInches,
  setPrimarySleeperWeight,
  setSecondarySleeperWeight,
  setPrimarySleeperBodyType,
  setSecondarySleeperBodyType,
  setPrimarySleeperBackPainHip,
  setPrimarySleeperBackPainShoulder,
  setPrimarySleeperBackPainLowerBackPain,
  setPrimarySleeperBackPainMidBack,
  setSecondarySleeperBackPainHip,
  setSecondarySleeperBackPainShoulder,
  setSecondarySleeperBackPainLowerBackPain,
  setSecondarySleeperBackPainMidBack,
  setSecondarySleeperFirmness,
  setPrimarySleeperFirmness,
  setPrimarySleeperBMI,
  setSecondarySleeperBMI,
  setPrimarySleeperEvrScore,
  setSecondarySleeperEvrScore,
  setPrimarySleeperFinalEvrScore,
  setSecondarySleeperFinalEvrScore,
  setPrimarySleeperName,
  setSecondarySleeperName,
} = mattressConfigurationSlice.actions;

export default mattressConfigurationSlice.reducer;

//Selectors
//General
export const isSingleSleeperSelector = state =>
  state.mattressConfiguration.mattressConfiguration.isSingleSleeper;
export const mattressConfigurationSelector = state =>
  state.mattressConfiguration;
export const cartSelector = state => state.mattressConfiguration.cart;
//Primary Sleeper
export const primarySleeperFirstNameSelector = state =>
  state.mattressConfiguration.mattressBuilder.primarySleeper.name;
export const primarySleeperPrimarySleepStyleSelector = state =>
  state.mattressConfiguration.mattressBuilder.primarySleeper.primarySleepStyle;
export const primarySleeperSecondarySleepStyleSelector = state =>
  state.mattressConfiguration.mattressBuilder.primarySleeper
    .secondarySleepStyle;
export const primarySleeperHeightSelector = state =>
  state.mattressConfiguration.mattressBuilder.primarySleeper.height;
export const primarySleeperHeightFeetSelector = state =>
  state.mattressConfiguration.mattressBuilder.primarySleeper.heightFeet;
export const primarySleeperHeightInchesSelector = state =>
  state.mattressConfiguration.mattressBuilder.primarySleeper.heightInches;
export const primarySleeperWeightSelector = state =>
  state.mattressConfiguration.mattressBuilder.primarySleeper.weight;
export const primarySleeperUnitSystemSelector = state =>
  state.mattressConfiguration.mattressBuilder.primarySleeper.unitSystem;
export const primarySleeperBodyTypeSelector = state =>
  state.mattressConfiguration.mattressBuilder.primarySleeper.bodyType;
export const primarySleeperPainPointsSelector = state =>
  state.mattressConfiguration.mattressBuilder.primarySleeper.painPoints;
export const primarySleeperLastSelectedPainPointSelector = state =>
  state.mattressConfiguration.mattressBuilder.primarySleeper
    .lastSelectedPainPoint;
export const primarySleeperFirmnessSelector = state =>
  state.mattressConfiguration.mattressBuilder.primarySleeper.firmness;
export const primarySleeperBmiSelector = state =>
  state.mattressConfiguration.mattressBuilder.primarySleeper.bmi;
export const primarySleeperEvrScoreSelector = state =>
  state.mattressConfiguration.mattressBuilder.primarySleeper.evrScore;

//Secondary Sleeper
export const secondarySleeperFirstNameSelector = state =>
  state.mattressConfiguration.mattressBuilder.secondarySleeper.name;
export const secondarySleeperPrimarySleepStyleSelector = state =>
  state.mattressConfiguration.mattressBuilder.secondarySleeper
    .primarySleepStyle;
export const secondarySleeperSecondarySleepStyleSelector = state =>
  state.mattressConfiguration.mattressBuilder.secondarySleeper
    .secondarySleepStyle;
export const secondarySleeperHeightSelector = state =>
  state.mattressConfiguration.mattressBuilder.secondarySleeper.height;
export const secondarySleeperHeightFeetSelector = state =>
  state.mattressConfiguration.mattressBuilder.secondarySleeper.heightFeet;
export const secondarySleeperHeightInchesSelector = state =>
  state.mattressConfiguration.mattressBuilder.secondarySleeper.heightInches;
export const secondarySleeperWeightSelector = state =>
  state.mattressConfiguration.mattressBuilder.secondarySleeper.weight;
export const secondarySleeperUnitSystemSelector = state =>
  state.mattressConfiguration.mattressBuilder.secondarySleeper.unitSystem;
export const secondarySleeperBodyTypeSelector = state =>
  state.mattressConfiguration.mattressBuilder.secondarySleeper.bodyType;
export const secondarySleeperPainPointsSelector = state =>
  state.mattressConfiguration.mattressBuilder.secondarySleeper.painPoints;
export const secondarySleeperLastSelectedPainPointSelector = state =>
  state.mattressConfiguration.mattressBuilder.secondarySleeper
    .lastSelectedPainPoint;
export const secondarySleeperFirmnessSelector = state =>
  state.mattressConfiguration.mattressBuilder.secondarySleeper.firmness;
export const secondarySleeperBmiSelector = state =>
  state.mattressConfiguration.mattressBuilder.secondarySleeper.bmi;
export const secondarySleeperEvrScoreSelector = state =>
  state.mattressConfiguration.mattressBuilder.secondarySleeper.evrScore;
